const memoryIds = new Map<string, string>();

/** An iframe must still work when the browser denies access to storage. */
export function persistentId(key: string, getStorage: () => Storage): string {
  const value = memoryIds.get(key) ?? crypto.randomUUID();
  try {
    const storage = getStorage();
    const existing = storage.getItem(key);
    if (existing) return existing;
    storage.setItem(key, value);
  } catch {
    // Retain a stable presence ID for this document without requiring storage.
  }
  memoryIds.set(key, value);
  return value;
}
